<template>
  <div class="breadcrumb-nav">
    <i class="el-icon-d-arrow-right"></i>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="item in list" :key="item.path" :to="{ path: item.path }">{{ item.name }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-nav {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 60px;

  i {
    color: #6a9c78;
    margin-right: 8px;
    font-weight: bold;
  }

  :deep(.el-breadcrumb__inner) {
    font-weight: normal;

    &.is-link {
      color: #666;
      &:hover {
        color: #6a9c78;
      }
    }
  }

  :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
    color: #333;
  }
}
</style>
